import App from '@/models/App'

export default class OrderingOrdererItemCategory extends App {
    static get entity() {
        return 'OrderingOrdererItemCategories'
    }

    static all() {
        return this.query().get()
    }

    static first() {
        return this.query().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingShipId: this.attr(''),
            name: this.attr(''),
            sort: this.attr(''),
            hasAlert: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            find(orderingShipId, orderingItemCategoryId) {
                return App.api().get(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/categories`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/categories`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingItemCategoryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            sorting(orderingShipId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/categories/sorting`,
                    params,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingItemCategoryId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingItemCategoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
